var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialOutlook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 34.0534C20 35.5254 21.1947 36.7201 22.6667 36.7201H45.3333C46.8053 36.7201 48 35.5254 48 34.0534V14.0534C48 12.5814 46.8053 11.3867 45.3333 11.3867H22.6667C21.1947 11.3867 20 12.5814 20 14.0534V34.0534Z",
    fill: "#03A9F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48 15.3535V14.0534C48 13.4827 47.8173 12.9561 47.5107 12.5228L32.492 21.7655L22.436 15.5575L21.5 18.0535L32.7787 24.7201L48 15.3535Z",
    fill: "#B3E5FC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 48L0 42.6667V5.33333L28 0V48Z",
    fill: "#0277BD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2883 17.1347C18.8243 15.4347 16.8936 14.584 14.5176 14.584C11.995 14.584 9.97365 15.476 8.44565 17.2547C6.92031 19.0373 6.15365 21.372 6.15365 24.2493C6.15365 26.976 6.90565 29.2013 8.40698 30.8973C9.90831 32.5947 11.863 33.444 14.2443 33.444C16.6976 33.444 18.6856 32.5747 20.2096 30.8107C21.7336 29.06 22.4923 26.7533 22.4923 23.8787C22.4923 21.0947 21.7576 18.8467 20.2883 17.1347ZM17.399 28.3667C16.6416 29.392 15.6136 29.9026 14.315 29.9026C13.063 29.9026 12.0496 29.3773 11.2683 28.32C10.4936 27.2733 10.1083 25.8387 10.1083 24.0387C10.1083 22.2573 10.4936 20.82 11.2683 19.7387C12.0496 18.6587 13.0923 18.124 14.4083 18.124C15.691 18.124 16.699 18.648 17.431 19.6947C18.171 20.7547 18.5416 22.2213 18.5416 24.108C18.543 25.928 18.1576 27.344 17.399 28.3667Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialOutlook);
export default __webpack_public_path__ + "static/media/social-outlook.db8db874.svg";
export { ForwardRef as ReactComponent };